import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { TruncateText } from '../TruncateText/TruncateText.esm.js';

const sizeVariants = {
    xs: "tw-text-2xs tw-font-normal",
    sm: "tw-text-xs tw-font-normal",
    md: "tw-text-sm tw-font-normal",
    lg: "tw-text-base tw-font-normal",
};
const appearanceVariants = {
    disabled: "tw-text-disabled dark:tw-text-dark-bg-disabled",
    link: "tw-text-link dark:tw-text-blue-400 hover:tw-underline",
    primary: "tw-text-default dark:tw-text-gray-100",
    secondary: "tw-text-secondary dark:tw-text-gray-400",
    error: "tw-text-red dark:tw-text-dark-bg-red",
};
/**
 * Renders text content in a `p` element by default.
 *
 * Link, `Bold`, and `Italic` components can be used within the text content.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Body, Bold, Italic } from "@panwds/react-ui";
 * ```
 */
function Body({ addClassName, appearance = "primary", children, hoverTitle, dataMetrics, dataTestId, as: Component = "p", size = "md", truncate = false, ...passThrough }) {
    const className = classNames(addClassName, "tw-m-0 tw-p-0 tw-font-lato", appearanceVariants[appearance], sizeVariants[size], truncate && "tw-flex");
    return (React.createElement(Component, { "data-metrics": dataMetrics, "data-testid": dataTestId || "body", className: className, title: hoverTitle, ...passThrough }, truncate ? React.createElement(TruncateText, null, children) : children));
}

export { Body };
//# sourceMappingURL=Body.esm.js.map
